export const AUTH_CALLBACK_PATH = '/callback'
